import { render } from "./WhoHasWorkedWithUs.vue?vue&type=template&id=b083d598"
import script from "./WhoHasWorkedWithUs.vue?vue&type=script&lang=ts"
export * from "./WhoHasWorkedWithUs.vue?vue&type=script&lang=ts"
script.render = render

export default script